import { useCallback, useContext, useEffect, useState } from 'react';
import { StudentAssignment, getStudentAssignments } from '../api/AssignmentStudentApi';
import ModuleContext from '../../../material/_contexts/ModuleContext';
import useThrowAsyncError from '../../../../hooks/useThrowAsyncError';

export default function useAssignmentsStudent() {
  const [assignments, setAssignments] = useState<StudentAssignment[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleError = useThrowAsyncError();
  const { module } = useContext(ModuleContext);

  const fetchAssignments = useCallback(async () => {
    if (!module) return;

    setIsLoading(true);

    try {
      const fetchedAssignments = await getStudentAssignments(module.id);
      setAssignments(fetchedAssignments);
    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  }, [module, handleError]);

  useEffect(() => {
    fetchAssignments();
  }, [fetchAssignments]);

  return { assignments, fetchAssignments, isLoading };
}
